import $ from 'jquery';
import util from 'util/Util.js';
import { View } from 'backbone';

import _template from 'properties/main/movie.ejs';
import assetCollection from 'AssetCollection.js';

class MainMovieView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=checkbox]' : 'updateCheckboxAttributes',
            'change #assetSelect' : 'assetSelected'

        };

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
    }

    assetSelected(ev) {
        ev.preventDefault();
        const propVal = ev.currentTarget.value;

        if (propVal) {
            this.model.set( 'assetId', propVal );
        }


    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        assetCollection.forEach( asset  => {
            var opt = document.createElement('option');
            opt.text = asset.get('name');
            opt.value = asset.get('id');

            var isImage = new RegExp('video/');
            if(isImage.test(asset.get('mimeType'))){
                $('#assetSelect').append(opt);
            }

        });

        // Set Asset Selection
        if(this.model.get('assetId')) {
            $('#assetSelect').find("option[value='"+this.model.get('assetId')+"']").attr('selected', true);
        }

        var self = this;
        $('#volume').slider({
            min: 0,
            max: 100,
            value: this.model.get('volume'),
            slide: function( event, ui ) {
                self.model.set('volume', ui.value, {silent: true} );
            }
        });

        let bLoop = util.isTrue(this.model.get('loop'));
        $(`input[name='loop']`).prop('checked', bLoop );

        let bAutoPlay = util.isTrue(this.model.get('autoPlay'));
        $(`input[name='autoPlay']`).prop('checked', bAutoPlay );

        let bMaintainAspectRatio = util.isTrue(this.model.get('maintainAspectRatio'));
        $(`input[name='maintainAspectRatio']`).prop('checked', bMaintainAspectRatio );

        if (this.config.hideTitle) {
            $('#movieSettingsTitle').addClass('hide');
        }


        this.delegateEvents();
        return this;
    }

}

export default MainMovieView;
